module.exports = __webpack_public_path__ + "front/img/b17.aac20608.jpg";